import { ITab } from '../../config';
import { FeeStatus } from '../enums';
import { ApplyScholarship } from '../offer';
import { ApplicantOfferRequirement } from '../offer/enums';

export type ConditionTextValues = {
  [key in ApplicantOfferRequirement]: string[];
};

interface IDisabledSections {
  criminalRecord: boolean;
}

export interface IApplyUniConfig {
  privacyPolicyConsentWording: ConsentWording;
  termsAndConditionConsentWording: ConsentWording;
  privacyPolicyUrl: string;
  termsAndConditionsUrl: string;
  depositText?: string;
  offerLetterStartTemplate: string;
  offerLetterEndTemplate: string;
  scholarships: ApplyScholarship[];
  disabledSections?: IDisabledSections;
}

export interface IApplyDashboardTabs {
  [category: string]: ITab[];
}

export interface ConsentWording {
  subtitle: string;
  header: string;
  bodyText: string;
  buttonLabel: string;
}

export interface IApplyUniConfigRequirement {
  id: string;
  enabled: boolean;
  type: UniConfigRequirementTask;
  category: UniConfigRequirementCategory;
  requirementText?: string; // For custom requirements
  label: string;
  conditions: {
    default?: string;
    [FeeStatus.Home]?: string;
    [FeeStatus.Overseas]?: string;
  };
}

export enum UniConfigRequirementCategory {
  System = 'System',
  Custom = 'Custom'
}

// TODO: This is a bit of a duplicate for now
export enum UniConfigRequirementTask {
  Passport = 'Passport',
  AcademicResults = 'AcademicResults',
  AcademicTranscript = 'AcademicTranscript',
  EnglishLanguageResults = 'EnglishLanguageResults',
  EnglishLanguageCertificate = 'EnglishLanguageCertificate',
  Upload = 'Upload',
  InfoOnly = 'InfoOnly'
}
